import { render, staticRenderFns } from "./MconAddMtrl.vue?vue&type=template&id=6dfef764&scoped=true&"
import script from "./MconAddMtrl.vue?vue&type=script&lang=js&"
export * from "./MconAddMtrl.vue?vue&type=script&lang=js&"
import style0 from "./MconAddMtrl.vue?vue&type=style&index=0&id=6dfef764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfef764",
  null
  
)

export default component.exports